<template>

  <div>

    <h2 style="display: inline;">{{ server.fqdn }} </h2>
    <p style="display: inline;">{{ server.description }}</p>

    <el-tabs v-model="currentTab">

      <el-tab-pane :label="$t('tab.dashboard')">
        <dashboard />
      </el-tab-pane>

      <el-tab-pane :label="$t('tab.settings')">
        <el-row>
            <el-col :span="12" :xs="24" :sm="12">

              <server-settings :server="server" />

              <licence-uploader :server="server" />

            </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane :label="$t('tab.child-servers')" v-if="childServers.length">
        <server-list :servers="childServers" />
      </el-tab-pane>

    </el-tabs>

  </div>

</template>

<script>
import Dashboard from '../Dashboard'
import ServerSettings from './ServerSettings'
import ParentServer from './ParentServer'
import LicenceUploader from './LicenceUploader'
import ServerList from './ServerList'

export default {
  name: 'server-details',
  data () {
    return {
      currentTab: '0'
    }
  },
  computed: {
    server () {
      const id = this.$route.params.id

      // Without id find the current server instance
      if (!id) {
        return this.$store.getters['servers/data'](this.$store.dispatch)
          .find((s) => s.self) || {}
      }

      return this.$store.getters['servers/findById'](id, this.$store.dispatch)
    },
    childServers () {
      return this.$store.getters['servers/data'](this.$store.dispatch)
        .filter((s) => s.parent_server_id === this.server.id)
    }
  },
  watch: {
    $route () {
      this.currentTab = 0
    }
  },
  components: {
    Dashboard,
    ServerSettings,
    ServerList,
    ParentServer,
    LicenceUploader
  }
}
</script>



// WEBPACK FOOTER //
// ServerDetails.vue?1f625be5